// extracted by mini-css-extract-plugin
module.exports = {"container":"oG-z","recos":"pG-z","productCardOverride":"qG-z"};